import endpoints, { axios } from "../../config/api";

async function deleteNewFolder(folderId: string) {
  return await (await axios.delete(endpoints.newfolders.byId(folderId))).data;
}

export default deleteNewFolder;
